var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47508 13.2709H4.02508C1.74425 13.2709 0.729248 12.2559 0.729248 9.97502V7.52502C0.729248 5.24419 1.74425 4.22919 4.02508 4.22919H6.47508C8.75592 4.22919 9.77092 5.24419 9.77092 7.52502V9.97502C9.77092 12.2559 8.75592 13.2709 6.47508 13.2709ZM4.02508 5.10419C2.21675 5.10419 1.60425 5.71669 1.60425 7.52502V9.97502C1.60425 11.7834 2.21675 12.3959 4.02508 12.3959H6.47508C8.28342 12.3959 8.89592 11.7834 8.89592 9.97502V7.52502C8.89592 5.71669 8.28342 5.10419 6.47508 5.10419H4.02508Z",
    fill: "#717680"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97508 9.77085H9.33342C9.09425 9.77085 8.89592 9.57252 8.89592 9.33335V7.52502C8.89592 5.71669 8.28342 5.10419 6.47508 5.10419H4.66675C4.42758 5.10419 4.22925 4.90585 4.22925 4.66669V4.02502C4.22925 1.74419 5.24425 0.729187 7.52508 0.729187H9.97508C12.2559 0.729187 13.2709 1.74419 13.2709 4.02502V6.47502C13.2709 8.75585 12.2559 9.77085 9.97508 9.77085ZM9.77092 8.89585H9.97508C11.7834 8.89585 12.3959 8.28335 12.3959 6.47502V4.02502C12.3959 2.21669 11.7834 1.60419 9.97508 1.60419H7.52508C5.71675 1.60419 5.10425 2.21669 5.10425 4.02502V4.22919H6.47508C8.75592 4.22919 9.77092 5.24419 9.77092 7.52502V8.89585Z",
    fill: "#717680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3646438e1f96449cf649c87f54e6ee7c.svg";
export { ForwardRef as ReactComponent };